<template>
  <div class="mb-3">
    <label>Formulario de inscripción <span class="text-danger">*</span></label>
    <div
      role="combobox"
      aria-haspopup="listbox"
      class="ng-input position-relative"
      :aria-expanded="showDropdown"
      :aria-owns="dropdownId"
    >
      <input
        :id="inputId"
        ref="searchInput"
        type="text"
        class="form-control"
        :class="{ 'is-invalid': showError }"
        placeholder="Seleccionar formulario..."
        v-model="searchQuery"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        @keydown="onKeyDown"
        aria-autocomplete="list"
        autocorrect="off"
        autocapitalize="none"
        :aria-controls="dropdownId"
        :aria-activedescendant="activeDescendant"
      />
    </div>

    <div
      v-show="showDropdown && filteredForms.length > 0"
      :id="dropdownId"
      role="listbox"
      aria-label="Options list"
      class="ng-dropdown-panel ng-select-bottom position-absolute w-100"
      style="
        z-index: 1050;
        opacity: 1;
        background: white;
        border: 1px solid #ced4da;
        border-top: none;
        border-radius: 0 0 0.375rem 0.375rem;
        max-height: 200px;
        overflow-y: auto;
      "
    >
      <div role="listbox" class="ng-dropdown-panel-items">
        <div
          v-for="(form, index) in filteredForms"
          :key="form.id"
          :id="`${dropdownId}-${index}`"
          class="ng-option"
          :class="{ 'ng-option-marked': highlightedIndex === index }"
          role="option"
          :aria-selected="selectedFormId === form.id"
          @mousedown.prevent="selectForm(form, index)"
          @mouseenter="highlightedIndex = index"
          style="
            padding: 8px 12px;
            cursor: pointer;
            border-bottom: 1px solid #f1f1f1;
          "
        >
          <span class="ng-option-label">{{ form.detail }}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="col-sm-6 col-12">
        <select
          v-model="selectedFilter"
          class="form-select form-select-sm"
          @change="clearError"
        >
          <option value="">Sin filtro</option>
          <option value="Todos">Todos</option>
          <option value="SER-Primaria">SER-Primaria</option>
          <option value="SER-Secundaria">SER-Secundaria</option>
          <option value="SEA-Alternativa">SEA-Alternativa</option>
          <option value="SEA-Especial">SEA-Especial</option>
          <option value="Maestro-Regular">Maestro-Regular</option>
          <option value="Maestro-Alternativa">Maestro-Alternativa</option>
          <option value="Maestro-Especial">Maestro-Especial</option>
          <option value="Maestro-ESFM">Maestro-ESFM</option>
          <option value="ESFM">ESFM</option>
        </select>
      </div> -->
  <input type="hidden" :name="fieldName" :value="selectedFormId" />
  <div v-if="showError" class="text-danger mt-1">Este campo es obligatorio</div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from "vue";

const props = defineProps({
  listEnrollment: { type: Array, default: () => [] },
  fieldName: { type: String, default: "enrollment" },
  modelValue: { type: [String, Number], default: "" },
  required: { type: Boolean, default: true },
});

const emit = defineEmits(["update:modelValue", "change"]);

// Refs
const searchInput = ref(null);
const searchQuery = ref("");
const selectedFilter = ref("");
const selectedFormId = ref(props.modelValue);
const showError = ref(false);
const showDropdown = ref(false);
const highlightedIndex = ref(-1);

const inputId = ref(`search-input-${Math.random().toString(36).substr(2, 9)}`);
const dropdownId = ref(`dropdown-${Math.random().toString(36).substr(2, 9)}`);

const filteredForms = computed(() => {
  let forms = props.listEnrollment || [];

  if (selectedFilter.value) {
    forms = forms.filter((f) => f.type === selectedFilter.value);
  }

  if (searchQuery.value && !selectedForm.value) {
    const q = searchQuery.value.toLowerCase();
    forms = forms.filter(
      (f) =>
        f.detail.toLowerCase().includes(q) || f.type.toLowerCase().includes(q)
    );
  }

  return forms;
});

const selectedForm = computed(() => {
  return (
    props.listEnrollment.find((f) => f.id === selectedFormId.value) || null
  );
});

const activeDescendant = computed(() => {
  if (showDropdown.value && highlightedIndex.value >= 0) {
    return `${dropdownId.value}-${highlightedIndex.value}`;
  }
  return null;
});

function onInput() {
  if (selectedForm.value && searchQuery.value !== selectedForm.value.detail) {
    selectedFormId.value = "";
    emit("update:modelValue", "");
  }

  showDropdown.value = true;
  highlightedIndex.value = -1;
  clearError();
}

function onFocus() {
  if (filteredForms.value.length > 0 && !selectedForm.value) {
    showDropdown.value = true;
  }
  clearError();
}

function onBlur() {
  setTimeout(() => {
    showDropdown.value = false;
    highlightedIndex.value = -1;
    if (!selectedForm.value && searchQuery.value) {
      searchQuery.value = "";
    }
  }, 150);
}

function onKeyDown(event) {
  const { key } = event;

  if (!showDropdown.value) {
    if (key === "ArrowDown" || key === "Enter") {
      showDropdown.value = true;
      highlightedIndex.value = 0;
      event.preventDefault();
    }
    return;
  }

  switch (key) {
    case "ArrowDown":
      event.preventDefault();
      highlightedIndex.value = Math.min(
        highlightedIndex.value + 1,
        filteredForms.value.length - 1
      );
      break;

    case "ArrowUp":
      event.preventDefault();
      highlightedIndex.value = Math.max(highlightedIndex.value - 1, 0);
      break;

    case "Enter":
      event.preventDefault();
      if (
        highlightedIndex.value >= 0 &&
        filteredForms.value[highlightedIndex.value]
      ) {
        selectForm(
          filteredForms.value[highlightedIndex.value],
          highlightedIndex.value
        );
      }
      break;

    case "Escape":
      showDropdown.value = false;
      highlightedIndex.value = -1;
      searchInput.value?.blur();
      break;
  }
}

function selectForm(form, index) {
  selectedFormId.value = form.id;
  searchQuery.value = form.detail;
  showDropdown.value = false;
  highlightedIndex.value = -1;

  emit("update:modelValue", form.id);
  emit("change", form);
  showError.value = false;

  nextTick(() => {
    searchInput.value?.blur();
  });
}

function clearError() {
  showError.value = false;
}

function validate() {
  if (props.required && !selectedFormId.value) {
    showError.value = true;
    return false;
  }
  showError.value = false;
  return true;
}

function clearSelection() {
  selectedFormId.value = "";
  searchQuery.value = "";
  selectedFilter.value = "";
  emit("update:modelValue", "");
  showError.value = false;

  nextTick(() => {
    searchInput.value?.focus();
  });
}

watch(
  () => props.modelValue,
  (v) => {
    selectedFormId.value = v;
    const chosen = props.listEnrollment.find((f) => f.id === v);
    if (chosen) {
      searchQuery.value = chosen.detail;
    } else {
      searchQuery.value = "";
    }
  }
);

watch(selectedFormId, (v) => {
  if (v !== props.modelValue) {
    emit("update:modelValue", v);
  }
});

defineExpose({ validate, clearSelection });
</script>

<style scoped>
.ng-input {
  position: relative;
}

.ng-dropdown-panel {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.ng-option {
  transition: background-color 0.15s ease-in-out;
}

.ng-option:hover,
.ng-option-marked {
  background-color: #e9ecef !important;
}

.ng-option:last-child {
  border-bottom: none;
}

.ng-option-label {
  display: block;
  width: 100%;
}

.form-control:focus + .ng-dropdown-panel {
  border-color: #86b7fe;
}

.form-control:focus {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.ng-input[aria-expanded="true"] .form-control {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
